import request from '@/router/axios';
var scope = 'server'; // const BASE_URL = 'http://yapi.thingcom.com/mock/89';
// const DEV_BASE_URL = 'http://192.168.1.114:9999';
// 查询 cabinet_type 柜子分类

export var queryCabinetType = function queryCabinetType(type) {
  return request({
    url: "/admin/dict/type/".concat(type),
    method: 'GET'
  });
}; // 配电站详情查询

export var queryStationDetail = function queryStationDetail(stationId) {
  return request({
    url: "/device/station/".concat(stationId),
    method: 'GET'
  });
}; // 查询用户当前的项目列表

export var queryGatewayList = function queryGatewayList(data) {
  return request({
    url: "/api/project/page",
    method: 'GET',
    params: data
  });
}; // 查询用户当前的经销商列表

export var queryDealerList = function queryDealerList() {
  return request({
    url: "/api/blade-user/dealer/list",
    method: 'GET'
  });
}; // 设置默认配电站

export var setDefaultStation = function setDefaultStation(data) {
  return request({
    url: "/api/device/config",
    method: 'GET',
    params: data
  });
}; // // 查询 device_type 仪表类型
// export const queryDeviceType = (type) => {
//   return request({
//     url: DEV_BASE_URL + `/admin/dict/type/${type}`,
//     method: 'GET'
//   })
// }